module.exports = __webpack_public_path__ + "assets/img/ac1.73bf659f.png";